// 本文中の出典参照 `[1]` / `[1][3]`。back の knowledge_answer prompt がこの表記で書かせる。
const CITATION_PATTERN = /\[(\d+)\]/g

export type AnswerSegment =
  | { kind: 'text'; text: string }
  | { kind: 'citation'; n: number }

/**
 * 回答本文を「地の文」と「出典バッジ」に割る。
 *
 * 出典に無い番号はバッジにせず地の文として残す。モデルが実在しない番号を書いた場合に
 * 押せないバッジを出さないため、かつ本文から黙って消さないため。
 */
export const splitByCitations = (
  content: string,
  knownNumbers: number[]
): AnswerSegment[] => {
  const known = new Set(knownNumbers)
  const segments: AnswerSegment[] = []
  let cursor = 0

  for (const match of content.matchAll(CITATION_PATTERN)) {
    const n = Number(match[1])
    if (!known.has(n) || match.index === undefined) continue
    if (match.index > cursor) {
      segments.push({ kind: 'text', text: content.slice(cursor, match.index) })
    }
    segments.push({ kind: 'citation', n })
    cursor = match.index + match[0].length
  }
  if (cursor < content.length) {
    segments.push({ kind: 'text', text: content.slice(cursor) })
  }
  return segments
}
